import { TaskShow } from './TaskShow';
import { TaskEdit } from './TaskEdit';
import { TaskCreate } from './TaskCreate';
import { TaskList } from './TaskList';

export default {
    list: TaskList,
    show: TaskShow,
    edit: TaskEdit,
    create: TaskCreate,
};
